import { Component } from "@angular/core";

@Component({
  selector: "app-patient-list-page",
  templateUrl: "./patient-list-page.component.html",
  styleUrls: ["./patient-list-page.component.scss"],
})
export class PatientListPageComponent {}
